/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
	getType,
	TYPE_REGISTER,
	TYPE_GENERAL_MANAGER,
	TYPE_GENERAL_BRANCH,
	TYPE_GENERAL_REGIONAL,
	TYPE_GAZINBOOK,
	TYPE_ADMIN,
	TYPE_REPORT,
	TYPE_SELLER,
	TYPE_CONTECOMIGO,
	TYPE_AFTERSALE,
	TYPE_CURRENT_PROMOTIONS,
	TYPE_CONSORTIUM,
	TYPE_RGIONAL_ANALYSIS,
	TYPE_SENIOR_REGIONAL,
	TYPE_SOCIAL_NETWORK,
	TYPE_NOTIFICATIONS,
} from "../../services/auth";

export const Sidebar = ({ menuActive, isOpenSidebar, setIsOpenSidebar }) => {
	const userType = getType();

	const [isOpenDropdownRegisters, setIsOpenDropdownRegister] =
		useState(false);
	const [isOpenDropdownPromotions, setIsOpenDropdownPromotions] =
		useState(false);

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<aside
			className={`app-sidebar ${isOpenSidebar ? "active" : ""}`}
			id="sidebar"
		>
			<div className="sidebar-header">
				<a className="sidebar-brand" href="#">
					<span className="highlight">Cartão</span> Express
				</a>
				<button
					type="button"
					className="sidebar-toggle"
					onClick={() => {
						setIsOpenSidebar(false);
					}}
				>
					<i className="fa fa-times"></i>
				</button>
			</div>

			{userType === TYPE_CURRENT_PROMOTIONS ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "current-promotions"
									? "active"
									: ""
							}
						>
							<Link to="/promocoes-vigentes">
								<div className="icon">
									<i
										className="fa fa-list"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Promoções Vigentes</div>
							</Link>
						</li>
						<li
							className={
								menuActive === "registers"
									? `dropdown active ${isOpenDropdownPromotions ? "open" : ""}`
									: `dropdown ${isOpenDropdownPromotions ? "open" : ""}`
							}
						>
							<a
								href="#"
								className="dropdown-toggle"
								data-toggle="dropdown"
								onClick={() => {
									setIsOpenDropdownPromotions(
										!isOpenDropdownPromotions,
									);
								}}
							>
								<div className="icon">
									<i
										className="fa fa-file-o"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Cadastros Ofertas</div>
							</a>
							<div
								className="dropdown-menu"
								style={{
									transform: "translateY(-50%)",
								}}
							>
								<ul>
									<li className="section">
										<i
											className="fa fa-file-o"
											aria-hidden="true"
										></i>{" "}
										Sistema
									</li>
									<li>
										<Link to="/produtos-oferta">
											Produtos em Oferta
										</Link>
									</li>

									<li>
										<Link to="/ofertas-vigentes/SOCIAL_MEDIA">
											Redes Sociais Vigentes
										</Link>
									</li>
									<li>
										<Link to="/ofertas-vigentes/VT">
											VTs Vigentes
										</Link>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			) : userType === TYPE_AFTERSALE ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "direct-mail" ? "active" : ""
							}
						>
							<Link to="/malas-diretas">
								<div className="icon">
									<i
										className="fa fa-suitcase"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Mala Direta</div>
							</Link>
						</li>

						<li className={menuActive === "forms" ? "active" : ""}>
							<Link to="/formularios">
								<div className="icon">
									<i
										className="fa fa-list-alt"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">
									Formulários de Pesquisa
								</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_GAZINBOOK ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li className={menuActive === "posts" ? "active" : ""}>
							<Link to="/posts">
								<div className="icon">
									<i
										className="fa fa-list"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Posts</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_SOCIAL_NETWORK ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li className={menuActive === "posts" ? "active" : ""}>
							<Link to="/rede-social-posts-para-aprovar">
								<div className="icon">
									<i
										className="fa fa-list"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Posts para Aprovar</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_NOTIFICATIONS ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "notifications-crm"
									? "active"
									: ""
							}
						>
							<Link to="/nova-notificacao">
								<div className="icon">
									<i
										className="fa fa-bell"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Nova Notificação</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_REPORT ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "report-by-date" ? "active" : ""
							}
						>
							<Link to="/report-by-date">
								<div className="icon">
									<i
										className="fa fa-table"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Relatório Cartões</div>
							</Link>
						</li>

						<li
							className={
								menuActive === "report-ranking-products"
									? "active"
									: ""
							}
						>
							<Link to="/report-ranking-products">
								<div className="icon">
									<i
										className="fa fa-table"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">
									Relatório Ranking de Produtos
								</div>
							</Link>
						</li>

						<li
							className={
								menuActive === "report-all-users"
									? "active"
									: ""
							}
						>
							<Link to="/report-all-users">
								<div className="icon">
									<i
										className="fa fa-table"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">
									Relatório Todos os Usuários
								</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_CONTECOMIGO ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "contecomigo" ? "active" : ""
							}
						>
							<Link to="/contecomigo">
								<div className="icon">
									<i
										className="fa fa-list"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">
									Tabloide Conte Comigo
								</div>
							</Link>
						</li>
						<li
							className={menuActive === "analise" ? "active" : ""}
						>
							<Link to="/analises-fale-com-vendedor">
								<div className="icon">
									<i
										className="fa fa-table"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">
									Analise Conte Comigo
								</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_CONSORTIUM ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "consórcio" ? "active" : ""
							}
						>
							<Link to="/usuarios-consorcio">
								<div className="icon">
									<i
										className="fa fa-list"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Usuários Consórcio</div>
							</Link>
						</li>
						<li className={menuActive === "dados" ? "active" : ""}>
							<Link to="/analises-consorcio">
								<div className="icon">
									<i
										className="fa fa-table"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Analise Consórcio</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_SENIOR_REGIONAL ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li className={menuActive === "dados" ? "active" : ""}>
							<Link to="/senior-regional">
								<div className="icon">
									<i
										className="fa fa-table"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">
									Analise CRM Regional
								</div>
							</Link>
						</li>
					</ul>
				</div>
			) : userType === TYPE_RGIONAL_ANALYSIS ? (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "dados-envos-regionais"
									? "active"
									: ""
							}
						>
							<Link to="/dados-envios-regional">
								<div className="icon">
									<i
										className="fa fa-list"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Dados Envios</div>
							</Link>
						</li>
					</ul>
				</div>
			) : (
				<div className="sidebar-menu">
					<ul className="sidebar-nav">
						<li
							className={
								menuActive === "dashboard" ? "active" : ""
							}
						>
							<Link to="/">
								<div className="icon">
									<i
										className="fa fa-tasks"
										aria-hidden="true"
									></i>
								</div>
								<div className="title">Dashboard</div>
							</Link>
						</li>

						{userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "new-card" ? "active" : ""
								}
							>
								<Link to="/novo-cartao">
									<div className="icon">
										<i
											className="fa  fa-plus"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">Criar Cartão</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL &&
							userType !== TYPE_SELLER ? (
							<li
								className={
									menuActive === "registers"
										? `dropdown active ${isOpenDropdownRegisters ? "open" : ""}`
										: `dropdown ${isOpenDropdownRegisters ? "open" : ""}`
								}
							>
								<a
									href="#"
									className="dropdown-toggle"
									data-toggle="dropdown"
									onClick={() => {
										setIsOpenDropdownRegister(
											!isOpenDropdownRegisters,
										);
									}}
								>
									<div className="icon">
										<i
											className="fa fa-file-o"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">Cadastros</div>
								</a>
								<div
									className="dropdown-menu custom-dropdown-position"
									style={{
										transform: isMobile ? "translateY(-55%)" : "translateY(-44%)",
									}}
								>
									<ul>
										<li className="section">
											<i
												className="fa fa-file-o"
												aria-hidden="true"
											></i>{" "}
											Sistema
										</li>
										<li>
											<Link to="/produtos">Produtos</Link>
										</li>
										<li>
											<Link to="/filiais">Filiais</Link>
										</li>
										<li>
											<Link to="/produtos-oferta">
												Produtos em Oferta
											</Link>
										</li>
										<li>
											<Link to="/user-change-password">
												Configurações de usuário
											</Link>
										</li>
										<li>
											<Link to="/ativar-usuario-por-cpf">
												Ativar Usuário
											</Link>
										</li>
										<li>
											<Link to="/campanhas">
												Campanhas
											</Link>
										</li>
										<li>
											<Link to="/anuncios">Anúncios</Link>
										</li>
										<li>
											<Link to="/mala-direta-tabloides-antigo">
												Mala Direta Tabloides (Antigo)
											</Link>
										</li>
										<li>
											<Link to="/musicas-fundo">
												Músicas de Fundo (Se vira nos
												30)
											</Link>
										</li>
										<li>
											<Link to="/capas-campanhas">
												Capas das Campanhas
											</Link>
										</li>
										<li>
											<Link to="/vinhetas">Vinhetas</Link>
										</li>
										<li>
											<Link to="/projetos-tabloide">
												Projetos de Tabloide
											</Link>
										</li>
										<li>
											<Link to="/arte-quadrada-campanhas">
												Campanhas Arte Quadrada
											</Link>
										</li>
										<li>
											<Link to="/arte-quadrada-anuncios">
												Anuncios Arte Quadrada
											</Link>
										</li>
										<li>
											<Link to="/aprenda-mais">
												Aprenda Mais
											</Link>
										</li>
										<li>
											<Link to="/funil-vendas">
												Funil de Vendas
											</Link>
										</li>
										<li>
											<Link to="/malas-diretas-crm">
												Malas Diretas CRM
											</Link>
										</li>
										<li>
											<Link to="/ofertas-vigentes/SOCIAL_MEDIA">
												Redes Sociais Vigentes
											</Link>
										</li>
										<li>
											<Link to="/ofertas-vigentes/VT">
												VTs Vigentes
											</Link>
										</li>
										<li>
											<Link to="/super-combo-campanhas">
												Super Combo Campanhas
											</Link>
										</li>
										<li>
											<Link to="/mala-direta-tabloides">
												Mala Direta Tabloides (Novo)
											</Link>
										</li>
										<li>
											<Link to="/importar-funil-produtos">
												Importar Funil de Produtos Associados
											</Link>
										</li>
									</ul>
								</div>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "notification-branch"
										? "active"
										: ""
								}
							>
								<Link to="/notificar-filial">
									<div className="icon">
										<i
											className="fa  fa-bell"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Notificar Filial
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "notification-state"
										? "active"
										: ""
								}
							>
								<Link to="/notificar-estado">
									<div className="icon">
										<i
											className="fa  fa-bell"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Notificar Estado
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "cpfs-authorized"
										? "active"
										: ""
								}
							>
								<Link to="/cpfs-autorizado">
									<div className="icon">
										<i
											className="fa  fa-lock"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										CPFs Autorizados
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "report-by-date"
										? "active"
										: ""
								}
							>
								<Link to="/report-by-date">
									<div className="icon">
										<i
											className="fa fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Relatório Cartões
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "products-offer"
										? "active"
										: ""
								}
							>
								<Link to="/produtos-oferta">
									<div className="icon">
										<i
											className="fa fa-product-hunt"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Produtos em Oferta
									</div>
								</Link>
							</li>
						) : null}

						{userType === TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "crm-data" ? "active" : ""
								}
							>
								<Link to="/branches-regional-crm">
									<div className="icon">
										<i
											className="fa fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">Dados CRM</div>
								</Link>
							</li>
						) : null}

						{userType === TYPE_GENERAL_BRANCH ? (
							<li
								className={
									menuActive === "crm-data" ? "active" : ""
								}
							>
								<Link to="/branch-crm-details">
									<div className="icon">
										<i
											className="fa fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">Dados CRM</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER ? (
							<li
								className={
									menuActive === "report-all-sent-by-date"
										? "active"
										: ""
								}
							>
								{/* <Link to="/report-all-sent-by-date">
									<div className="icon">
										<i
											className="fa fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Relatório de Envios CRM
									</div>
								</Link> */}
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "report-ranking-products"
										? "active"
										: ""
								}
							>
								<Link to="/report-ranking-products">
									<div className="icon">
										<i
											className="fa fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Relatório Ranking de Produtos
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "report-clients-ranking"
										? "active"
										: ""
								}
							>
								<Link to="/report-clients-ranking">
									<div className="icon">
										<i
											className="fa fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Relatório Ranking de Clientes
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "report-all-users"
										? "active"
										: ""
								}
							>
								<Link to="/report-all-users">
									<div className="icon">
										<i
											className="fa fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Relatório Todos os Usuários
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "report-sends-sales"
										? "active"
										: ""
								}
							>
								<Link to="/report-sents-sales">
									<div className="icon">
										<i
											className="fa  fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Relatório Envios x Vendas
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "report-negotiation"
										? "active"
										: ""
								}
							>
								<Link to="/report-negotiations">
									<div className="icon">
										<i
											className="fa  fa-table"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Relatório Negociação
									</div>
								</Link>
							</li>
						) : null}

						{userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "importar-precos-express"
										? "active"
										: ""
								}
							>
								<Link to="/importar-preco">
									<div className="icon">
										<i
											className="fa  fa-download"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Importar Preços Cartão Express
									</div>
								</Link>
							</li>
						) : null}
                        {userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "campanhas-funil-mensagens"
										? "active"
										: ""
								}
							>
								<Link to="/campanhas-funil-mensagens">
									<div className="icon">
										<i
											className="fa  fa-list"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Campanhas Funil de Texto
									</div>
								</Link>
							</li>
						) : null}
                        {userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "itens-crm-filial"
										? "active"
										: ""
								}
							>
								<Link to="/itens-crm-filial">
									<div className="icon">
										<i
											className="fa  fa-database"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Dados Crm Filial
									</div>
								</Link>
							</li>
						) : null}
                        {userType !== TYPE_REGISTER &&
							userType !== TYPE_SELLER &&
							userType !== TYPE_GENERAL_MANAGER &&
							userType !== TYPE_GENERAL_BRANCH &&
							userType !== TYPE_GENERAL_REGIONAL ? (
							<li
								className={
									menuActive === "envios-crm-hoje"
										? "active"
										: ""
								}
							>
								<Link to="/envios-crm-hoje">
									<div className="icon">
										<i
											className="fa  fa-send"
											aria-hidden="true"
										></i>
									</div>
									<div className="title">
										Envios CRM Hoje
									</div>
								</Link>
							</li>
						) : null}
					</ul>
				</div>
			)}

			<div className="sidebar-footer"></div>
		</aside>
	);
};
